var make = require('./make_');
var arrEvery = require('../array/every');
var objEvery = require('../object/every');

    /**
     */
    module.exports = make(arrEvery, objEvery);





//////////////////
// WEBPACK FOOTER
// ./~/mout/collection/every.js
// module id = 1573
// module chunks = 0 1 2